import React, { useCallback, useEffect, useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import { WrappedFieldProps } from 'redux-form';

type RenderDateTimePickerProps = WrappedFieldProps;

const RenderDateTimePicker: React.FC<RenderDateTimePickerProps> = ({
  input: { value, onChange },
  meta,
  ...rest
}) => {
  const [dateValue, setDateValue] = useState<Date | undefined>(undefined);

  useEffect(() => {
    if (value) {
      const date = value instanceof Date ? value : new Date(value);
      setDateValue(Number.isNaN(date.getTime()) ? undefined : date);
    } else {
      setDateValue(undefined);
    }
  }, [value]);

  const handleChange = useCallback(
    (val: Date | Date[] | null) => {
      if (val instanceof Date && !Number.isNaN(val.getTime())) {
        setDateValue(val);
        onChange(val);
      } else {
        setDateValue(undefined);
        onChange(null);
      }
    }, [onChange],
  );

  return (
    <div>
      <DateTimePicker
        value={dateValue}
        onChange={handleChange}
        {...rest}
      />
      {meta.touched && meta.error && (
        <div style={{ color: 'red', marginTop: 4 }}>{meta.error}</div>
      )}
    </div>
  );
};

export default RenderDateTimePicker;
